export default "__VITE_ASSET__CnT2c8oL__"